import { createFileRoute } from '@tanstack/react-router';
import { MetaConnectPage } from '@/features/meta-connect/pages/meta-connect-page';

/** `?meta=` is the outcome of the Instagram / Facebook login the API redirects back with (`ticket` = Facebook Page picker). */
export const Route = createFileRoute('/_app/settings/meta-channels')({
  component: MetaConnectPage,
  validateSearch: (s: Record<string, unknown>): { meta?: string; ticket?: string } => ({
    meta: typeof s.meta === 'string' ? s.meta : undefined,
    ticket: typeof s.ticket === 'string' ? s.ticket : undefined,
  }),
});
